import '../../../../../Components/Admin/Dashboard/AdSchedule.css';
import React, { useEffect, useState } from 'react';
import moment from 'moment';
import axios from 'axios';
import Paper from '@mui/material/Paper';
import {
    Scheduler,
    WeekView,
    Appointments,
} from '@devexpress/dx-react-scheduler-material-ui';



const ScheduleList = () => {
    const currentDate = '2018-11-01';
    const [schedule, setSchedule] = useState([]);
    React.useEffect(() => {
        axios.get("/api/admin/current_year_schedule_list").then(res => {
            if (res.data.status === 200) {

                var schedule_data = [];

                res.data.schedule.forEach(function (item) {
                    schedule_data.push({
                        title: item.title.toUpperCase(),
                        startDate: moment(item.startDate).format('YYYY-MM-DD') + 'T' + moment(item.from, 'HH:mm:ss').format('H:m'),
                        endDate: moment(item.startDate).format('YYYY-MM-DD') + 'T' + moment(item.to, 'HH:mm:ss').format('H:m')
                    });
                });

                setSchedule(schedule_data);


            }
        });
    }, []);

    return (

        <>
            <div className="card card-bg mt-3 py-2">
                <Paper>
                    <Scheduler data={schedule} height={660}>
                        <WeekView startDayHour={0} endDayHour={24} />
                        <Appointments />
                    </Scheduler>
                </Paper>
            </div>

        </>
    )
}
export default ScheduleList;




